module.exports = __webpack_public_path__ + "img/iconWoDeCaoZuoShouCe.c81c6e68.svg";